import React from "react"
import styled from "styled-components"
import ClipLoader from "react-spinners/dist/spinners/ClipLoader"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"

const spinnerSize = 100

const SubmitSpinnerContainer = styled.div`
  margin: auto;
  width: ${spinnerSize}px;
  height: ${spinnerSize}px;
`

function CustomReportSubmitSpinner({ theme }) {
  return (
    <SubmitSpinnerContainer>
      <ClipLoader loading color={theme.primaryColor} size={spinnerSize} />
    </SubmitSpinnerContainer>
  )
}

CustomReportSubmitSpinner.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(CustomReportSubmitSpinner)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/CustomReportSubmitSpinner.jsx